module.exports = __webpack_public_path__ + "static/media/zolty_stres.5933ab58.png";